import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import axios from '@/common/axios'


const ADD_ORDITEMS = 'ADD_ORDITEMS'
const ADD_ORDITEM_TO_STACK = 'ADD_ORDITEM_TO_STACK'
const DELETE_ORDITEM_FROM_STACK = 'DELETE_ORDITEM_FROM_STACK'
const EDIT_ORDITEM_IN_STACK = 'EDIT_ORDITEM_IN_STACK'
const LOGOUT_USER = 'LOGOUT_USER'

//console.log('createOrderitem: '+ ADD_ORDITEMS)

const orderitem_obj = {
    namespaced: true,
    state: {
        orderitem: []
    },
    mutations: {
        ADD_ORDITEMS (state, data) {
            state.orderitem = state.orderitem.concat(data)
        },
        ADD_ORDITEM_TO_STACK (state, orderitem_obj) {
            state.orderitem.unshift(orderitem_obj)
        },
        DELETE_ORDITEM_FROM_STACK (state, orderitem_obj) {
            if (state.orderitem.length) {
                let i = state.orderitem.map(orderitem_obj => orderitem_obj.id).indexOf(orderitem_obj.id)
                state.orderitem.splice(i, 1)
            }
        },
        EDIT_ORDITEM_IN_STACK (state, orderitem_obj) {
            if (state.orderitem.length) {
                let i = state.orderitem.map(orderitem_obj => orderitem_obj.id).indexOf(orderitem_obj.id)
                Vue.set(state.orderitem, i, orderitem_obj)
            }
        },
        LOGOUT_USER (state) {
            state.orderitem = []
        }
    },
    getters: {
        orderitem (state) {
            return state.orderitem
        }
    },
    actions: {
        // API Calls
        async getUsersOrderitem ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('orderitem', {params: {sort: data.sort, order: data.order, page: data.page, limit: data.limit}})
                commit(ADD_ORDITEMS, response.data)
                //console.log('getUsersOrderitem: ', response)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },

        async getAFOrderitem ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                //console.log('getOrderitem data: ', data)
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('orderitemAF', {params: {af_user_id: data.af_user_id, order_id: data.order_id}})
                //console.log('getOrderitem response.data: ', response.data)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },

        async getOrderitem ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                //console.log('getOrderitem data: ', data)
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('orderitem/' + data)
                //console.log('getOrderitem response.data: ', response.data)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },
        async createOrderitem ({ dispatch, commit, getters, rootGetters }, data) {
            //console.log('createOrderitem data: ', data)
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                return await axios.post('orderitem', data)
            } catch (error) {
                throw new Error(error)
            }
        },

        // Only Mutations
        async userLogout ({ dispatch, commit, getters, rootGetters }) {
            try {
                commit(LOGOUT_USER)
            } catch (error) {
                throw new Error(error)
            }
        },
        async addOrderitemToStack ({ dispatch, commit, getters, rootGetters }, orderitem_obj) {
            try {
                commit(ADD_ORDITEM_TO_STACK, orderitem_obj)
            } catch (error) {
                throw new Error(error)
            }
        },
        async deleteOrderitemFromStack ({ dispatch, commit, getters, rootGetters }, orderitem_obj) {
            try {
                commit(DELETE_ORDITEM_FROM_STACK, orderitem_obj)
            } catch (error) {
                throw new Error(error)
            }
        },
        async editOrderitemInStack ({ dispatch, commit, getters, rootGetters }, orderitem_obj) {
            try {
                commit(EDIT_ORDITEM_IN_STACK, orderitem_obj)
            } catch (error) {
                throw new Error(error)
            }
        }
    }
}

export default orderitem_obj
